module.exports = __webpack_public_path__ + "img/user.e4c0b155.png";